import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { DefaultModalProps } from './default-modal.component';

interface ViewProps {
    modalType: string;
    width: any;
    modalRef: React.RefObject<null>;
}

const useDefaultModal = (props: DefaultModalProps): ViewProps => {
    const modalRef = useRef(null);
    const modalType = props.type ? 'modal-' + props.type.valueOf() : 'modal-prompt';
    const width = props.customWidth !== undefined ? { width: props.customWidth + '%' } : {};
    const location = useLocation();

    useEffect(() => {
        // Only listen while open. A closed modal must not capture document mousedown —
        // stopPropagation here previously blocked Floating UI dropdowns (e.g. language select).
        if (!props.show) return;

        const handleClickOutside = (e: any) => {
            if (e && e.target && (e.target as any).closest('.ignore-modal-close')) return;
            const queryParams = new URLSearchParams(location.search);
            if (queryParams.has('details')) {
                const details = queryParams.get('details');
                const detailsArray = details!.slice(1, -1).split(',');
                if (!props.id) return;
                const newArray = detailsArray[detailsArray.length - 1].slice(1, -1).split('-');
                newArray.shift();
                if (newArray.join('-') == props.id) {
                    if (modalRef.current && !(modalRef.current as any).contains(e.target)) {
                        props.handleClose && props.handleClose();
                    }
                }
            } else if (modalRef.current && !(modalRef.current as any).contains(e.target)) {
                props.handleClose && props.handleClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [location.search, props.handleClose, props.id, props.show]);

    return {
        modalRef,
        modalType,
        width
    };
};

export default useDefaultModal;
